/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ network: NonNullable<unknown> }} Social_Link_LabelInputs */



/**
* | output |
* | --- |
* | "AWP Marine on {network}" |
*
* @param {Social_Link_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const social_link_label = /** @type {((inputs: Social_Link_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Link_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ (`${i?.network} 上的 AWP Marine`)
	return /** @type {LocalizedString} */ (`AWP Marine on ${i?.network}`)
});